<template>
  <el-form class="sn-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item>
      <template slot="label">
        预览
      </template>
      <div>{{ snPreview }}</div>
    </el-form-item>
    <el-form-item prop="prefix">
      <template slot="label">
        前缀
      </template>
      <div>
        <el-popover placement="top-start" v-model="prefixVisible" style="margin-right:10px">
          <div style="display: grid">
            <el-button
              v-for="(item, index) in datePattern"
              :key="index"
              style="margin-bottom: 5px; margin-left: 0"
              @click="updatePrefix(item.label, 'prefix'), (prefixVisible = false)"
            >
              {{ item.label }}
            </el-button>
            <el-button type="text" @click="setNewDatePattern('prefix')">自定义</el-button>
          </div>
          <el-button slot="reference" type="text">插入时间</el-button>
        </el-popover>
        <el-button
          type="text"
          @click="updatePrefix(control.key, 'prefix')"
          :disabled="isSelectedKey"
        >
          插入字段
        </el-button>
      </div>
      <el-input v-model="control.prefix" placeholder="前缀"></el-input>
    </el-form-item>
    <el-form-item prop="width">
      <template slot="label">
        编号位数
      </template>
      <el-input-number v-model="control.width" :min="1" :max="10" size="small"></el-input-number>
    </el-form-item>
    <el-form-item prop="hex">
      <template slot="label">
        编号进制
      </template>
      <el-select v-model="control.hex" placeholder="">
        <el-option
          v-for="(item, index) in hexList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="key">
      <template slot="label">
        递增关联
      </template>
      <el-select v-model="control.key" clearable placeholder="请选择" @change="snKeyChange">
        <el-option
          v-for="(item, index) in objFieldList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="suffix">
      <template slot="label">后缀</template>
      <div>
        <el-popover placement="top-start" v-model="suffixVisible" style="margin-right:10px">
          <div style="display: grid">
            <el-button
              v-for="(item, index) in datePattern"
              :key="index"
              style="margin-bottom: 5px; margin-left: 0"
              @click="updatePrefix(item.label, 'suffix'), (suffixVisible = false)"
            >
              {{ item.label }}
            </el-button>
            <el-button type="text" @click="setNewDatePattern('suffix')">自定义</el-button>
          </div>
          <el-button slot="reference" type="text">插入时间</el-button>
        </el-popover>
        <el-button
          type="text"
          @click="updatePrefix(control.key, 'suffix')"
          :disabled="isSelectedKey"
        >
          插入字段
        </el-button>
      </div>
      <el-input v-model="control.suffix" placeholder="后缀"></el-input>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">唯一</template>
      <el-checkbox v-model="control.unique"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import { previewSn } from "@/api/sheet/sheet"
import { transFieldControl } from "@/utils/sheet"
import {
  datePattern,
  hexList
} from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"

export default {
  name: "sn-control",
  props: {
    control: Object,
    fields: Array
  },
  data() {
    return {
      datePattern,
      hexList,
      prefixVisible: false,
      suffixVisible: false,
      snPreview: "",
      debouncedPreviewSn: this._.debounce(this.previewSn, 300),
      oldSnKey: ""
    }
  },
  computed: {
    objFieldList() {
      return this.fields
        .map(c => transFieldControl(c))
        .map(v => {
          return {
            label: v.name,
            type: v._dataType,
            value: v._cid
          }
        })
        .filter(v => v.value !== this.control._cid && ["string", "option"].includes(v.type))
    },
    isSelectedKey() {
      return this.control.key === "" || !this.objFieldList.some(x => x.value == this.control.key)
    },
    fix() {
      const { prefix, suffix, width } = this.control
      return { prefix, suffix, width }
    }
  },
  created() {
    this.debouncedPreviewSn()
    this.oldSnKey = this.control.key
  },
  watch: {
    fix: {
      handler(newVal) {
        this.debouncedPreviewSn()
      },
      deep: true
    }
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    previewSn() {
      let cid = this.control.key
      let name = (this.objFieldList.find(v => v.value == cid) || { label: "" }).label
      let str = this.control.prefix + this.pad(1, this.control.width) + this.control.suffix
      previewSn(cid, name, str)
        .then(res => {
          this.snPreview = res
        })
        .catch(() => {
          this.$message.error("请求出错，请刷新重试！")
        })
    },
    pad(num, n) {
      return Array(n > num ? n - ("" + num).length + 1 : 0).join(0) + num
    },
    updatePrefix(value, attr) {
      if (attr == "prefix") {
        this.control.prefix += "{" + value + "}"
      } else {
        this.control.suffix += "{" + value + "}"
      }
    },
    setNewDatePattern(attr) {
      this.$prompt("在下方输入自定义格式，将日期按需要的方式显示", "自定义日期格式", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          this.updatePrefix(value, attr)
        })
        .catch(() => {
          this.$message.info("取消输入")
        })
    },
    snKeyChange() {
      let key = "{" + this.oldSnKey + "}"
      this.control.prefix = this.control.prefix.replace(key, "")
      this.control.suffix = this.control.suffix.replace(key, "")
      this.oldSnKey = this.control.key
    }
  }
}
</script>

<style lang="scss" scoped>
.sn-control {
}
</style>
